<template>
	<div>
		<div class="row">
			<div class="col-6 mb-4" v-for="form in forms" :key="form.id">
				<div class="well" @click="goToSignoff">
					<h1>{{form.title}}</h1>
					<p>{{form.note}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			forms: [
				{
					id: 1 ,
					title: 'DOPS 1' ,
					note: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed convallis arcu. Curabitur ultricies, dui vel molestie laoreet, nisi odio feugiat ipsum, iaculis condimentum nibh leo ullamcorper magna.'
				},
				{
					id: 2 ,
					title: 'DOPS 2' ,
					note: 'Aenean vel neque gravida, eleifend orci vel, tincidunt leo. Ut suscipit nisl orci, at porttitor augue fringilla porttitor. Integer sit amet ex quam. Quisque orci ex, gravida vitae hendrerit nec, mollis in augue.'
				},
				{
					id: 3 ,
					title: 'DOPS 3' ,
					note: 'Ut suscipit nisl orci, at porttitor augue fringilla porttitor. Integer sit amet ex quam. Integer sit amet ex quam. Quisque orci ex, gravida vitae hendrerit nec, mollis in augue.'
				},
				{
					id: 4 ,
					title: 'DOPS 4' ,
					note: 'Quisque orci ex, gravida vitae hendrerit nec, mollis in augue. Suspendisse elementum lobortis quam ac aliquet.'
				},
				{
					id: 5 ,
					title: 'DOPS 5' ,
					note: 'Vivamus tristique, enim facilisis fermentum maximus, nisi dui egestas ligula, nec volutpat nisl elit non sapien. Phasellus orci nibh, interdum vel risus vel, consectetur cursus turpis. Duis imperdiet tellus non venenatis consectetur.'
				},
				{
					id: 6 ,
					title: 'DOPS 6' ,
					note: 'Quisque orci ex, gravida vitae hendrerit nec, mollis in augue. Suspendisse elementum lobortis quam ac aliquet. Vivamus tristique, enim facilisis fermentum maximus, nisi dui egestas ligula, nec volutpat nisl elit non sapien. Phasellus orci nibh, interdum vel risus vel, consectetur cursus turpis. Duis imperdiet tellus non venenatis consectetur.'
				}
			]
		}
	},
	mounted() {
	},
	methods: {
		goToSignoff: function() {
			this.$router.push('/reflections/newsignoff');
		}
	},
};
</script>
